import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
var _excluded = ["children", "elevation"];
import '../../css-tokens';
/* eslint-disable react/no-array-index-key */

import React, { forwardRef } from 'react';
import cx from 'classnames';
import system from '../../system';
import Paper from '../Paper';
import styles from './index.module.css';
var SYSTEM_PROPS = ['marginProps', 'floatProps', 'flexProps'];

const WideList = /*#__PURE__*/function () {
  const WideList = /*#__PURE__*/forwardRef(function (_ref, ref) {
    var children = _ref.children,
        elevation = _ref.elevation,
        props = _objectWithoutPropertiesLoose(_ref, _excluded);

    var _system = system(props, SYSTEM_PROPS),
        className = _system[0],
        style = _system[1],
        rest = _system[2];

    return /*#__PURE__*/React.createElement(Paper, _extends({}, rest, {
      borderRadius: 2,
      elevation: elevation,
      className: cx(styles.root, className),
      style: style,
      ref: ref
    }), children);
  });
  WideList.displayName = 'WideList';
  WideList.identifier = WideList.displayName; // used in docs website

  WideList.clonableProps = SYSTEM_PROPS;
  WideList.defaultProps = {
    elevation: 1
  };
  return WideList;
}();

export default WideList;